// extracted by mini-css-extract-plugin
module.exports =  {"container":"APSxTg6","divider":"DEHtziM"};